var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2614_5208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1113 15.1258C13.1113 14.5119 12.6129 14.0181 11.999 14.0181C11.3852 14.0181 10.8867 14.5119 10.8867 15.1258C10.8867 15.4208 11.0039 15.7037 11.2125 15.9123C11.4211 16.1209 11.704 16.2381 11.999 16.2381",
    stroke: "#7C7C7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8867 17.35C10.8867 17.9592 11.3852 18.4577 11.999 18.4577M11.999 18.4577C12.6129 18.4577 13.1113 17.9592 13.1113 17.35C13.1113 16.7362 12.6129 16.2377 11.999 16.2377M11.999 18.4577V19.0208M11.999 13.4551V14.0182",
    stroke: "#7C7C7C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 20.4617C14.3322 20.4617 16.2234 18.5705 16.2234 16.2377C16.2234 13.9048 14.3322 12.0137 11.9994 12.0137C9.66654 12.0137 7.77539 13.9048 7.77539 16.2377C7.77539 18.5705 9.66654 20.4617 11.9994 20.4617Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7521 9.52881H2.24937C1.89789 9.52881 1.56081 9.6684 1.31223 9.91689C1.06366 10.1654 0.923951 10.5024 0.923828 10.8539V21.2611C0.923828 21.6127 1.06348 21.9498 1.31207 22.1984C1.56066 22.447 1.89781 22.5867 2.24937 22.5867H21.7521C22.1037 22.5867 22.4408 22.447 22.6894 22.1984C22.938 21.9498 23.0777 21.6127 23.0777 21.2611V10.8539C23.0776 10.5024 22.9378 10.1654 22.6893 9.91689C22.4407 9.6684 22.1036 9.52881 21.7521 9.52881Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7521 4.85547H2.24937C2.07526 4.85547 1.90285 4.88977 1.742 4.95641C1.58115 5.02306 1.435 5.12074 1.31191 5.24387C1.18881 5.36701 1.09118 5.51319 1.0246 5.67407C0.958009 5.83494 0.923768 6.00736 0.923828 6.18147V21.2618C0.923828 21.6133 1.06348 21.9505 1.31207 22.1991C1.56066 22.4477 1.89781 22.5873 2.24937 22.5873H21.7521C21.9262 22.5873 22.0987 22.553 22.2595 22.4864C22.4204 22.4197 22.5665 22.322 22.6896 22.1989C22.8127 22.0758 22.9103 21.9296 22.9769 21.7687C23.0435 21.6078 23.0777 21.4354 23.0777 21.2613V6.18101C23.0776 5.82953 22.9378 5.49249 22.6893 5.24401C22.4407 4.99552 22.1036 4.85547 21.7521 4.85547Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9432 4.85527H9.05859V2.37542C9.05859 1.84465 9.48921 1.41357 10.02 1.41357H13.9818C14.5126 1.41357 14.9432 1.84419 14.9432 2.37542V4.85619V4.85527Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2614_5208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default __webpack_public_path__ + "static/media/BD.49ef5d6b87e5780828e5c19a5556c076.svg";
export { ForwardRef as ReactComponent };